import { ExportTableDialog } from "@/ds";

import { CargaEstado } from "../components/carga-estado";
import { CargaLegend } from "../components/carga-legend";
import { CargaSubbar } from "../components/carga-subbar";
import { CargaToolbar } from "../components/carga-toolbar";
import { GanttLocal } from "../components/gantt-local";
import { GanttLocalObras } from "../components/gantt-local-obras";
import { GanttPrintChrome } from "../components/gantt-print-chrome";
import { IndicadoresDialog } from "@/shared/components/indicadores-dialog";
import { ResolverConflitoLocalDialog } from "../components/resolver-conflito-local";
import type { CargaLocalViewModel } from "./types-carga-local";
import styles from "./carga-local.module.scss";

/** Carga de Trabalho: perspectiva Local (US-2023), agrupada por Local ou por Obra. */
export function CargaLocalView({
  estado,
  capaImpressao,
  legendaImpressao,
  toolbar,
  chips,
  removerChip,
  legenda,
  ganttLocal,
  ganttLocalObras,
  resolver,
  exportacao,
  indicadores,
}: CargaLocalViewModel) {
  if (estado.status === "forbidden") return <CargaEstado {...estado} />;

  return (
    <div className={styles.container} data-testid="carga-de-trabalho-screen">
      <GanttPrintChrome {...capaImpressao} legend={<CargaLegend {...legendaImpressao} />} />
      <CargaToolbar {...toolbar} />
      <CargaSubbar chips={chips} onRemoverChip={removerChip}>
        <CargaLegend {...legenda} />
      </CargaSubbar>
      <CargaEstado {...estado} />

      {ganttLocal ? <GanttLocal {...ganttLocal} /> : null}
      {ganttLocalObras ? <GanttLocalObras {...ganttLocalObras} /> : null}

      {resolver ? <ResolverConflitoLocalDialog {...resolver} /> : null}

      {exportacao.aberta ? (
        <ExportTableDialog
          listName="carga de trabalho"
          isExporting={exportacao.exportando}
          onExport={exportacao.exportar}
          onCancel={exportacao.fechar}
        />
      ) : null}

      {indicadores.aberto ? (
        <IndicadoresDialog
          opcoes={indicadores.opcoes}
          value={indicadores.valor}
          onSave={indicadores.salvar}
          onCancel={indicadores.cancelar}
        />
      ) : null}
    </div>
  );
}
